import { CircularProgress, List, ListItem, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: "520px",
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, fontFamily: "Quicksand" }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export const CreateGradesDialog = ({
  gradehandleClose,
  openGrade,
  Grade,
  setGrade,
  createPayGrade,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={gradehandleClose}
      aria-labelledby="customized-dialog-title"
      open={openGrade}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={gradehandleClose}
      >
        <div className="foundation_header">Create Grade</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Grade.name}
              onChange={(e) => setGrade({ ...Grade, name: e.target.value })}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={Grade.description}
              onChange={(e) =>
                setGrade({ ...Grade, description: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Start Date</label>
            <input
              type="date"
              value={Grade.start_date}
              onChange={(e) =>
                setGrade({ ...Grade, start_date: e.target.value })
              }
            />
          </div>
          <div className="Box">
            <label>Min Gross Salary</label>
            <input
              name="min_gross_salary"
              value={Grade.min_gross_salary}
              onChange={(e) =>
                setGrade({ ...Grade, min_gross_salary: e.target.value })
              }
            />
          </div>
          <div className="Box">
            <label>Max Gross Salary</label>
            <input
              name="max_gross_salary"
              value={Grade.max_gross_salary}
              onChange={(e) =>
                setGrade({ ...Grade, max_gross_salary: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Effective Status</label>
            <select
              name="effectiveStatus"
              value={Grade.grade_status}
              onChange={(e) => setGrade({ ...Grade, status: e.target.value })}
              id=""
            >
              <option value="">Choose status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={gradehandleClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={createPayGrade}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const EditGradeDialog = ({
  handleEditGradeClose,
  editGrade,
  Grade,
  setGrade,
  updateGrade,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleEditGradeClose}
      aria-labelledby="customized-dialog-title"
      open={editGrade !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleEditGradeClose}
      >
        <div className="foundation_header">Edit Grade</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Form_Box">
          <div className="Box">
            <label>name</label>
            <input
              name="name"
              value={Grade.name}
              onChange={(e) => setGrade({ ...Grade, name: e.target.value })}
            />
          </div>

          <div className="Box">
            <label>description</label>
            <input
              name="description"
              value={Grade.description}
              onChange={(e) =>
                setGrade({ ...Grade, description: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Start Date</label>
            <input
              type="date"
              value={Grade.start_date}
              onChange={(e) =>
                setGrade({ ...Grade, start_date: e.target.value })
              }
            />
          </div>
          <div className="Box">
            <label>Min Gross Salary</label>
            <input
              name="min_gross_salary"
              value={Grade.min_gross_salary}
              onChange={(e) =>
                setGrade({ ...Grade, min_gross_salary: e.target.value })
              }
            />
          </div>
          <div className="Box">
            <label>Max Gross Salary</label>
            <input
              name="max_gross_salary"
              value={Grade.max_gross_salary}
              onChange={(e) =>
                setGrade({ ...Grade, max_gross_salary: e.target.value })
              }
            />
          </div>

          <div className="Box">
            <label>Effective Status</label>
            <select
              name="effectiveStatus"
              value={Grade.grade_status}
              onChange={(e) => setGrade({ ...Grade, status: e.target.value })}
              id=""
            >
              <option value="">Choose status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleEditGradeClose} className="Btn">
            Cancel
          </button>
          <button
            className="Btn"
            onClick={updateGrade}
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "submit"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const DeleteGradeDialog = ({
  handleDeleteGradeClose,
  deleteGrade,
  deletePayGrade,
  isLoading,
}) => {
  const dashboardTheme = window.localStorage.getItem("theme");
  return (
    <BootstrapDialog
      onClose={handleDeleteGradeClose}
      aria-labelledby="customized-dialog-title"
      open={deleteGrade !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleDeleteGradeClose}
      >
        <div className="foundation_header">Delete Grade</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <div className="Confirmation">Are you sure?</div>
      </DialogContent>
      <DialogActions>
        <div className="Form_Btn_Wrapper">
          <button onClick={handleDeleteGradeClose} className="Btn">
            Cancel
          </button>
          <button
            style={{
              backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
            }}
            className="Delete_Btn"
            onClick={deletePayGrade}
          >
            {isLoading === true ? (
              <CircularProgress color="inherit" size={20} />
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </DialogActions>
    </BootstrapDialog>
  );
};

export const ViewGradeDialog = ({ handleViewGradeClose, GradeViewopen }) => {
  return (
    <BootstrapDialog
      onClose={handleViewGradeClose}
      aria-labelledby="customized-dialog-title"
      open={GradeViewopen !== null}
    >
      <BootstrapDialogTitle
        id="customized-dialog-title"
        onClose={handleViewGradeClose}
      >
        <div className="foundation_header">View Pay Grade</div>
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <List>
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Name</label>
            <p>{GradeViewopen?.grade}</p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Minimum Grade Salary</label>
            <p>
              {parseFloat(GradeViewopen?.min_gross_salary).toLocaleString(
                "en-Us",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}
            </p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Maximum Grade Salary</label>
            <p>
              {parseFloat(GradeViewopen?.max_gross_salary).toLocaleString(
                "en-Us",
                { minimumFractionDigits: 2, maximumFractionDigits: 2 }
              )}
            </p>
          </ListItem>
          <Divider style={{ backgroundColor: "rgba(0,0,0,0.5" }} />
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <label>Description</label>
            <p>{GradeViewopen?.description}</p>
          </ListItem>
        </List>
      </DialogContent>
    </BootstrapDialog>
  );
};
